(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var RADIUS = 78, AMP = 5;

    function init(root) {
      if (!root || root.dataset.gpHeroReady === '1') return;
      root.dataset.gpHeroReady = '1';

      if (root.classList.contains('gp-hero--still')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

      var h1 = root.querySelector('.gp-hero__title');
      if (!h1) return;

      // Split the heading into per-letter spans. The h1 carries an aria-label,
      // so assistive tech still reads the sentence rather than the letters.
      var letters = [];
      (function wrap(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (c) {
          if (c.nodeType === 3) {
            var frag = document.createDocumentFragment();
            Array.prototype.slice.call(c.textContent).forEach(function (ch) {
              if (ch === ' ' || ch === '\n' || ch === '\t') {
                frag.appendChild(document.createTextNode(ch));
              } else {
                var s = document.createElement('span');
                s.textContent = ch;
                frag.appendChild(s);
                letters.push(s);
              }
            });
            node.replaceChild(frag, c);
          } else if (c.nodeType === 1 && c.tagName !== 'BR') {
            wrap(c);
          }
        });
      })(h1);

      if (!letters.length) return;

      // Cache letter centres; measuring inside pointermove forces layout per letter.
      var pts = null, raf = null;
      function measure() {
        pts = letters.map(function (s) {
          var b = s.getBoundingClientRect();
          return { s: s, x: b.left + b.width / 2, y: b.top + b.height / 2 };
        });
      }
      function reset() {
        letters.forEach(function (s) { s.style.transform = ''; });
      }
      function move(cx, cy) {
        if (!pts) measure();
        for (var i = 0; i < pts.length; i++) {
          var o = pts[i], dx = o.x - cx, dy = o.y - cy;
          var d = Math.sqrt(dx * dx + dy * dy);
          if (d < RADIUS && d > 0.001) {
            var f = (1 - d / RADIUS) * AMP;
            o.s.style.transform = 'translate(' + (dx / d * f) + 'px,' + (dy / d * f) + 'px)';
          } else {
            o.s.style.transform = '';
          }
        }
      }

      root.addEventListener('pointerenter', measure);
      root.addEventListener('pointermove', function (e) {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { move(e.clientX, e.clientY); });
      });
      root.addEventListener('pointerleave', function () {
        if (raf) cancelAnimationFrame(raf);
        reset();
      });

      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(function () { pts = null; reset(); }, 150);
      }, { passive: true });
      window.addEventListener('scroll', function () { pts = null; }, { passive: true });
    }

    function boot(scope) {
      (scope || document).querySelectorAll('.gp-hero').forEach(init);
    }

    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', function () { boot(); });

    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
